<template>
  <!-- <transition name="modal" > -->
  <div id="modal-template">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :class="{onlySafari: isSafari}">
          <button class="modal-close-button" @click="$emit('close') & closeGA4Click('click', 'cerrar', 'popup informacion del producto')">X</button>
          <div class="modal-body-body">
            <slot name="body">
              <div class="img-top-container">
                <img :src="indioIcon" />
              </div>
              <div class="info-container">
                <div class="info-col-middle col-img-product">
                  <img :src="botella" alt="Botella Indio" />
                </div>
                <div class="info-col col-text-info" :class="{onlySafari: isSafari}">
                  <h5 class="mSection-title">Ingredientes:</h5>
                  <p class="mParagraph mText-2">
                    Agua, malta de <b>cebada</b>, <b>cebada</b> como adjunto, <br />
                    maíz como adjunto, extracto de lúpulo,<br/> caramelo clase III.
                  </p>
                  <h5 class="mSection-title" style="margin-top: 2vw;">Información nutricional por 100 ml</h5>
                  <p class="mParagraph mText-2">
                    Contenido energético 36.1 kcal (150.5 KJ),
                    grasas totales 0 g de los cuales: grasas
                    saturadas 0 g, hidratos de carbono disponible
                    3.14 g, de los cuales: azucares 0.93 g, proteínas
                    0.23 g, sodio {{'<'}} 0.02 g.
                  </p>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import indioIcon from "@/assets/Indio_Logo_Simple.png";
import botella from "@/assets/indio_botella.png";
import tagFunctions from '@/utils/tagFunctions.js';
import Bowser from "bowser";
export default {
  name: "ModalInfoProduct",
  data() {
    return {
      indioIcon,
      botella,
      isSafari: false
    };
  },
  components: {},
  props: {
    wichModal: {
      type: String,
      default: "none"
    }
  },
  methods: {
    closeGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
  },
  async mounted(){
    tagFunctions.user_interactionPush('view', 'popup informacion del producto', 'footer');
  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  },
};
</script>
   
<style lang="scss" scoped>
@import "~@/styles/modalInfoProduct.scss";
</style>